import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { PieChart, Pie, Cell } from 'recharts';
import { connect } from 'react-redux';

import './submission.css';

class SubmissionsSummary extends Component {
  render() {
    const submissions =
      this.props.submissions_overview[this.props.outlet.id] || {};
    const submissionsBreakdown = submissions.submission_breakdown || {};
    const colors = ['#5dba5b', '#B82445', '#ffc734'];
    const data = [
      {
        name: 'Approved',
        value: submissionsBreakdown.APPROVED || 0
      },
      {
        name: 'Declined',
        value: submissionsBreakdown.DECLINED || 0
      },
      {
        name: 'Pending',
        value: submissionsBreakdown.PENDING || 0
      }
    ];
    return (
      <Row className="submission-overview">
        <Col className="submission-pie" md={3}>
          {submissions.total_submissions > 0 ? (
            <PieChart width={150} height={150} className="submission-pie-chart">
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                fill="#8884d8"
                outerRadius="100%"
              >
                {data.map((entry, index) => (
                  <Cell key={index} fill={colors[index % colors.length]} />
                ))}
              </Pie>
            </PieChart>
          ) : (
            <p>NO SUBMISSIONS MADE</p>
          )}
        </Col>
        <Col md={2}>
          <div className="chart-title">Submitted</div>
          <div className="submission-count is-submitted">
            {submissions.total_submissions || 0}
          </div>
        </Col>
        <Col md={2}>
          <div className="chart-title">Approved</div>
          <div className="submission-count is-approved">
            {submissionsBreakdown.APPROVED || 0}
          </div>
        </Col>
        <Col md={2}>
          <div className="chart-title">Declined</div>
          <div className="submission-count is-declined">
            {submissionsBreakdown.DECLINED || 0}
          </div>
        </Col>
        <Col md={2}>
          <div className="chart-title">Processing</div>
          <div className="submission-count is-pending">
            {submissionsBreakdown.PENDING || 0}
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  submissions_overview: state.submissions.user_submissions_overview || {}
});

export default connect(mapStateToProps)(SubmissionsSummary);



// WEBPACK FOOTER //
// ./src/components/submissions/dashboard/submissions-summary.js